/**
 * 用户相关API服务
 * 包含登录、注册、退出登录等用户认证相关的接口调用
 */

import { fetcher } from '../base/fetcher'
import type {
  Account,
  CaptchaLoginRequest,
  LoginRequest,
  RegisterRequest,
} from '../types/user.types'

/**
 * 用户相关API路径常量
 */
export const API_PATHS = {
  /** 账号密码登录 */
  LOGIN: '/login/login',
  /** 验证码登录 */
  CAPTCHA_LOGIN: '/login/login/captcha',
  /** 用户注册 */
  REGISTER: '/login/register/login',
  /** 退出登录 */
  LOGOUT: '/login/exit',
} as const

/**
 * 用户服务对象
 * 提供所有用户相关的API调用方法
 */
export const userService = {
  /**
   * 账号密码登录
   * @param data 登录参数（手机号/用户名 + 密码）
   * @returns 用户账号信息
   */
  login: (data: LoginRequest) => fetcher.post<Account>(API_PATHS.LOGIN, data),

  /**
   * 验证码登录
   * @param data 验证码登录参数（手机号 + 验证码）
   * @returns 用户账号信息
   */
  loginWithCaptcha: (data: CaptchaLoginRequest) =>
    fetcher.post<Account>(API_PATHS.CAPTCHA_LOGIN, data),

  /**
   * 用户注册
   * @param data 注册参数（用户名、密码、手机号、验证码）
   * @returns 注册成功后的用户账号信息
   */
  register: (data: RegisterRequest) =>
    fetcher.post<Account>(API_PATHS.REGISTER, data),

  /**
   * 退出登录
   * @returns null（无返回数据）
   */
  logout: () => fetcher.post<null>(API_PATHS.LOGOUT),
}
